import * as types from "./types";
import { combineReducers } from "redux";

function dataSaved(state = { status: false, msg: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, msg: "" }
      : state;
}

function citasDeVenta(state = [], { type, payload }) {
  return type === types.ADDED_CITA_DE_VENTA
    ? [
        ...state.filter(
          ({ id, idColegio }) =>
            id !== payload.id && idColegio === payload.idColegio
        ),
        payload
      ]
    : type === types.REMOVED_CITA_DE_VENTA
      ? state.filter(({ id }) => id !== payload.id)
      : type === types.CHANGED_CITA_DE_VENTA
        ? state.map(item => (item.id === payload.id ? payload : item))
        : type === types.LIMPIAR_CITAS_DE_VENTA
          ? []
          : state;
}

const reducer = combineReducers({
  dataSaved,
  citasDeVenta
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasCitas/reducers.js